<template>
<div>
    <v-layout>
        <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
                <v-toolbar-title>{{ $t('Ticket-Issuing') }}</v-toolbar-title>
            </v-toolbar>
        </v-flex>
    </v-layout>
    <v-container fluid>

        <v-layout row wrap>

            <router-link :to="{ name: 'bilet-genelparametreler' }">
                <v-btn style="width:200px" color="info" dark>{{$t('General-Parameters')}}
                </v-btn>
            </router-link>

            <router-link :to="{ name: 'bilet-raporparametre' }">
                <v-btn style="width:200px" color="info" dark> {{$t('Report-Parameters')}}
                </v-btn>
            </router-link>

            <!-- <v-btn style="width:200px" @click="vergibilgigetir()" color="info" dark> {{ $t('Tax-Issuing') }}
            </v-btn> -->
            <!-- <router-link :to="{ name: 'bilet-gecicivergi' }">
                <v-btn style="width:200px" color="info" dark>{{$t('Provisional-Tax-Definitions')}}
                </v-btn>
            </router-link> -->

            <v-btn style="width:200px" @click="servisbilgigetir()" color="info" dark> {{ $t('Service-Parameters') }}
            </v-btn>

            <v-btn style="width:200px" @click="firmabilgilerigetir()" color="info" dark>{{$t('Company-Information')}}
            </v-btn>

            <router-link :to="{ name: 'bilet-kesenkisi' }">
                <v-btn style="width:200px" color="info" dark>{{$t('Ticket-Agent')}}
                </v-btn>
            </router-link>

            <router-link :to="{ name: 'parkur' }">
                <v-btn style="width:200px" color="info" dark>{{$t('Airline')}}/ {{$t('Route')}}/{{$t('Class')}}
                </v-btn>
            </router-link>

        </v-layout>
        <v-dialog v-model="dialog" scrollable="" max-width="500px">
            <v-card color="grey lighten-5">
                <v-card-title>{{$t('Company-Information')}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>

                    <v-flex xs12 sm12 md12 pa-1>
                        <v-card class="white--text">
                            <v-card flat="">
                                <v-card-actions>
                                    <v-layout justify-space-between column>
                                        <v-text-field hide-details="" v-model="FirmaParametre.FirmaAdi" :label="$t('Corporate-Name')">
                                        </v-text-field>
                                        <v-text-field hide-details="" v-model="FirmaParametre.FirmaAdres" :label="$t('Corporate-Address') + '-1'">
                                        </v-text-field>
                                        <v-text-field hide-details="" v-model="FirmaParametre.FirmaAdres2" :label="$t('Corporate-Address') + '-2'">
                                        </v-text-field>
                                        <v-layout>
                                            <v-text-field hide-details="" v-model="FirmaParametre.BankaSube" :label="$t('Bank-Branch')">
                                            </v-text-field>
                                            <v-text-field hide-details="" v-model="FirmaParametre.BankaHesapNo" :label="$t('Bank-Account-No')">
                                            </v-text-field>
                                        </v-layout>
                                        <v-layout>
                                            <v-text-field hide-details="" v-model="FirmaParametre.Tel1" :label="$t('Phonenumber_label') + '-1'">
                                            </v-text-field>
                                            <v-text-field hide-details="" v-model="FirmaParametre.Tel2" :label="$t('Phonenumber_label') + '-2'">
                                            </v-text-field>
                                        </v-layout>
                                        <v-layout>
                                            <v-text-field hide-details="" v-model="FirmaParametre.Tel3" :label="$t('Phonenumber_label') + '-3'">
                                            </v-text-field>
                                            <v-text-field hide-details="" v-model="FirmaParametre.Tel4" :label="$t('Phonenumber_label') + '-4'">
                                            </v-text-field>
                                        </v-layout>
                                        <v-layout>
                                            <v-text-field hide-details="" v-model="FirmaParametre.VergiDaire" :label="$t('Taxcenter_label')">
                                            </v-text-field>
                                            <v-text-field hide-details="" v-model="FirmaParametre.VergiNo" :label="$t('Taxnumber_label')">
                                            </v-text-field>
                                        </v-layout>
                                        <v-layout>
                                            <v-text-field hide-details="" v-model="FirmaParametre.UlkeKod" :label="$t('Country-Language-Code')">
                                            </v-text-field>
                                            <v-text-field hide-details="" v-model="FirmaParametre.UlkeIataKod" :label="$t('Country-IATA-Code')">
                                            </v-text-field>
                                        </v-layout>
                                        <v-layout>
                                            <v-text-field hide-details="" v-model="FirmaParametre.ParaBirimi" :label="$t('Currency-Unit')">
                                            </v-text-field>
                                            <v-text-field hide-details="" v-model="FirmaParametre.AcentaVatKod" :label="$t('Agency-VAT-Code')">
                                            </v-text-field>
                                        </v-layout>
                                        <v-layout>
                                            <v-text-field hide-details="" v-model="FirmaParametre.SmsMusteriKod" :label="'SMS '+ $t('Customer-Code')">
                                            </v-text-field>
                                            <v-text-field hide-details="" v-model="FirmaParametre.SmsSifre" :label="$t('SMS-Password')">
                                            </v-text-field>
                                        </v-layout>
                                        <v-text-field hide-details="" v-model="FirmaParametre.XmlSaticiKod" :label="$t('XML-Seller-Code')">
                                        </v-text-field>
                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>

                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="Kaydet()">{{ $t('OK') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogservis" scrollable="" max-width="800px">
            <v-card>
                <v-card-title>{{$t('Service-Definitions')}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-layout row wrap>
                        <v-card flat="">
                            <v-card-actions>
                                <v-layout row="" wrap justify-start="" fill-height="">
                                    <v-flex xs12 sm6 md8>
                                        <v-layout row wrap>
                                            <v-flex xs12 sm4 md12>
                                                <v-layout>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-layout align-center fill-height="">
                                                            <v-chip color="red" label>
                                                                <span class="white--text"> 11- {{ $t('Domestic-Low-Cost') }}</span>
                                                            </v-chip>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md3>
                                                        <parainput :isPositive="true" :simge="getparabirimi()" v-model="ServisParametre.Fiyat11" :id="'Fiyat11'" :etiket="$t('Priceice')" :autocomplete="'autocomplete'"></parainput>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-autocomplete id="doviz11" v-model="ServisParametre.Doviztip11" hide-details="" disabled="" :items="doviztipi" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs1 sm1 md1>
                                                        <v-checkbox id="11" name="11" @change="DefaultIcAyarlar(ServisParametre.DefaultServis11,'11')" v-model="ServisParametre.DefaultServis11"></v-checkbox>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm4 md12>

                                                <v-layout>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-layout align-center fill-height="">
                                                            <v-chip color="red" label>
                                                                <span class="white--text"> 12- {{ $t('Domestic-Eco-Cost') }}</span>
                                                            </v-chip>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md3>
                                                        <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Priceice')" v-model="ServisParametre.Fiyat12" :autocomplete="'autocomplete'"></parainput>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-autocomplete hide-details="" v-model="ServisParametre.Doviztip12" disabled="" :items="doviztipi" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')">
                                                        </v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs1 sm1 md1>
                                                        <v-checkbox v-model="ServisParametre.DefaultServis12" @change="DefaultIcAyarlar(ServisParametre.DefaultServis12,'12')"></v-checkbox>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm4 md12>

                                                <v-layout>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-layout align-center fill-height="">
                                                            <v-chip color="red" label>
                                                                <span class="white--text"> 13- {{ $t('Internal-Business-Cost') }} </span>
                                                            </v-chip>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md3>
                                                        <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Priceice')" v-model="ServisParametre.Fiyat13" :autocomplete="'autocomplete'"></parainput>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-autocomplete hide-details="" disabled="" :items="doviztipi" v-model="ServisParametre.Doviztip13" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs1 sm1 md1>
                                                        <v-checkbox v-model="ServisParametre.DefaultServis13" @change="DefaultIcAyarlar(ServisParametre.DefaultServis13,'13')"></v-checkbox>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm4 md12>
                                                <v-layout>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-layout align-center fill-height="">
                                                            <v-chip color="red" label>
                                                                <span class="white--text"> 15- {{this.$t('Internal-Return')}}</span>
                                                            </v-chip>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md3>
                                                        <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Priceice')" v-model="ServisParametre.Fiyat15" :autocomplete="'autocomplete'"></parainput>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-autocomplete hide-details="" disabled="" :items="doviztipi" v-model="ServisParametre.Doviztip15" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs1 sm1 md1>
                                                        <v-checkbox @change="DefaultIcAyarlar(ServisParametre.DefaultServis15,'15')" v-model="ServisParametre.DefaultServis15"></v-checkbox>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm4 md12>

                                                <v-layout>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-layout align-center fill-height="">
                                                            <v-chip color="red" label>
                                                                <span class="white--text caption"> 19- {{ $t('Domestic-Reservation-Variation') }}</span>
                                                            </v-chip>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md3>
                                                        <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Priceice')" v-model="ServisParametre.Fiyat19" :autocomplete="'autocomplete'"></parainput>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-autocomplete hide-details="" disabled="" :items="doviztipi" v-model="ServisParametre.Doviztip19" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs1 sm1 md1>
                                                        <v-checkbox @change="DefaultIcAyarlar(ServisParametre.DefaultServis19,'19')" v-model="ServisParametre.DefaultServis19"></v-checkbox>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4>
                                        <v-layout row wrap>
                                            <v-flex xs12 sm6 md12>
                                                <v-checkbox v-model="icYuzdedenHesapla.Yuzdeden" :label="$t('Domestic-Line-Percentage-Calculation')" hide-details>
                                                </v-checkbox>
                                            </v-flex>
                                            <v-flex xs12 sm6 md12>
                                                <v-select hide-details="" v-model="icYuzdedenHesapla.HesapTipi" :items="hesaptipi" clearable item-text="text" item-value="value" :label="$t('Account-Type')"></v-select>
                                            </v-flex>
                                            <v-flex xs12 sm6 md12>
                                                <yuzdeinput :isPositive="true" :etiket="$t('Percentage') + '%'" v-model="icYuzdedenHesapla.HesapYuzde" :autocomplete="'autocomplete'"></yuzdeinput>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-card-actions>
                        </v-card>

                    </v-layout>
                    <v-layout>
                        <v-divider></v-divider>
                    </v-layout>

                    <v-layout row wrap>
                        <v-card color="" flat="">
                            <v-card-actions>
                                <v-layout row="" wrap justify-start="" fill-height="">
                                    <v-flex xs12 sm6 md8>
                                        <v-layout row wrap>
                                            <v-flex xs12 sm4 md12>
                                                <v-layout>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-layout align-center fill-height="">
                                                            <v-chip color="info" label>
                                                                <span class="white--text"> 21- {{ $t('International-Short-Cost') }}</span>
                                                            </v-chip>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md3>
                                                        <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Priceice')" v-model="ServisParametre.Fiyat21" :autocomplete="'autocomplete'"></parainput>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip21" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs1 sm1 md1>
                                                        <v-checkbox @change="DefaultDisAyarlar(ServisParametre.DefaultServis21,'21')" v-model="ServisParametre.DefaultServis21"></v-checkbox>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm4 md12>

                                                <v-layout>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-layout align-center fill-height="">
                                                            <v-chip color="info" label>
                                                                <span class="white--text"> 22- {{ $t('International-Short-Business') }} </span>
                                                            </v-chip>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md3>
                                                        <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Priceice')" v-model="ServisParametre.Fiyat22" :autocomplete="'autocomplete'"></parainput>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip22" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs1 sm1 md1>
                                                        <v-checkbox @change="DefaultDisAyarlar(ServisParametre.DefaultServis22,'22')" v-model="ServisParametre.DefaultServis22"></v-checkbox>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm4 md12>

                                                <v-layout>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-layout align-center fill-height="">
                                                            <v-chip color="info" label>
                                                                <span class="white--text"> 31- {{ $t('International-Long-Eco') }}</span>
                                                            </v-chip>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md3>
                                                        <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Priceice')" v-model="ServisParametre.Fiyat31" :autocomplete="'autocomplete'"></parainput>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip31" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs1 sm1 md1>
                                                        <v-checkbox @change="DefaultDisAyarlar(ServisParametre.DefaultServis31,'31')" v-model="ServisParametre.DefaultServis31"></v-checkbox>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm4 md12>
                                                <v-layout>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-layout align-center fill-height="">
                                                            <v-chip color="info" label>
                                                                <span class="white--text"> 32- {{ $t('International-Long-Business') }}</span>
                                                            </v-chip>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md3>
                                                        <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Priceice')" v-model="ServisParametre.Fiyat32" :autocomplete="'autocomplete'"></parainput>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip32" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs1 sm1 md1>
                                                        <v-checkbox @change="DefaultDisAyarlar(ServisParametre.DefaultServis32,'32')" v-model="ServisParametre.DefaultServis32"></v-checkbox>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm4 md12>

                                                <v-layout>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-layout align-center fill-height="">
                                                            <v-chip color="info" label>
                                                                <span class="white--text caption"> 33- {{ $t('First-Class') }}</span>
                                                            </v-chip>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md3>
                                                        <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Priceice')" v-model="ServisParametre.Fiyat33" :autocomplete="'autocomplete'"></parainput>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip33" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs1 sm1 md1>
                                                        <v-checkbox @change="DefaultDisAyarlar(ServisParametre.DefaultServis33,'33')" v-model="ServisParametre.DefaultServis33"></v-checkbox>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-layout align-center fill-height="">
                                                            <v-chip color="info" label>
                                                                <span class="white--text caption"> 40- {{$t('Foreign-Return')}}</span>
                                                            </v-chip>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md3>
                                                        <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Priceice')" v-model="ServisParametre.Fiyat40" :autocomplete="'autocomplete'"></parainput>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip40" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')">
                                                        </v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs1 sm1 md1>
                                                        <v-checkbox @change="DefaultDisAyarlar(ServisParametre.DefaultServis40,'40')" v-model="ServisParametre.DefaultServis40"></v-checkbox>

                                                    </v-flex>
                                                </v-layout>
                                                <v-layout>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-layout align-center fill-height="">
                                                            <v-chip color="info" label>
                                                                <span class="white--text caption"> 44- {{$t('Foreign-Reservation-Change')}}</span>
                                                            </v-chip>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md3>
                                                        <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Priceice')" v-model="ServisParametre.Fiyat44" :autocomplete="'autocomplete'"></parainput>
                                                    </v-flex>
                                                    <v-flex xs12 sm4 md4>
                                                        <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip44" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs1 sm1 md1>
                                                        <v-checkbox @change="DefaultDisAyarlar(ServisParametre.DefaultServis44,'44')" v-model="ServisParametre.DefaultServis44"></v-checkbox>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm6 md4>
                                        <v-layout align-content-start="" fill-height="" row wrap>
                                            <v-flex xs12 sm6 md12>
                                                <v-checkbox v-model="DisYuzdedenHesapla.Yuzdeden" :label="$t('International-Lines-Percentage-Calculation')" hide-details></v-checkbox>
                                            </v-flex>
                                            <v-flex xs12 sm6 md12>
                                                <v-select hide-details="" v-model="DisYuzdedenHesapla.HesapTipi" :items="hesaptipi" clearable item-text="text" item-value="value" :label="$t('Account-Type')"></v-select>
                                            </v-flex>
                                            <v-flex xs12 sm6 md12>
                                                <yuzdeinput :isPositive="true" :etiket="$t('Percentage') + '%'" v-model="DisYuzdedenHesapla.HesapYuzde" :autocomplete="'autocomplete'"></yuzdeinput>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-card-actions>
                        </v-card>

                    </v-layout>

                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="blue darken-1" @click.native="dialogservis=false" flat>{{$t("cancel_button")}}</v-btn>
                    <v-btn color="blue darken-1" @click="serviskaydet()" flat>{{$t("save_button")}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogvergi" scrollable="" persistent="" max-width="800px">
            <v-card color="grey lighten-5">
                <v-card-title>{{ $t('Tax-Issuing') }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>

                    <v-layout>
                        <v-flex xs12 sm4 md2>
                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Amount')" :aktif="'false'" v-model="defaultvalue" :autocomplete="'autocomplete'">
                            </parainput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.BiletKdv" :autocomplete="'autocomplete'">
                            </yuzdeinput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <v-select hide-details="" v-model="VergiParametre.BiletDH" :items="itemsei" clearable label="E/I">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md5>
                            <v-text-field hide-details="" v-model="VergiParametre.BiletAciklama" :label="$t('Description')">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                            <v-checkbox v-model="VergiParametre.BiletDisp" hide-details></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 sm4 md2>
                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'Pta Tutar'" :aktif="'false'" v-model="defaultvalue" :autocomplete="'autocomplete'">
                            </parainput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.PtaKdv" :autocomplete="'autocomplete'">
                            </yuzdeinput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <v-select hide-details="" v-model="VergiParametre.PtaDH" :items="itemsei" clearable label="E/I">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md5>
                            <v-text-field hide-details="" v-model="VergiParametre.PtaAciklama" :label="$t('Description')">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                            <v-checkbox v-model="VergiParametre.PtaDisp" hide-details></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 sm4 md2>
                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'YFF Tutar'" v-model="VergiParametre.YffTutar" :autocomplete="'autocomplete'">
                            </parainput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.YffKdv" :autocomplete="'autocomplete'">
                            </yuzdeinput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <v-select hide-details="" v-model="VergiParametre.YffDH" :items="itemsei" clearable label="E/I">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md5>
                            <v-text-field hide-details="" v-model="VergiParametre.YffAciklama" :label="$t('Description')">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                            <v-checkbox v-model="VergiParametre.YffDisp" hide-details></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 sm4 md2>
                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Landing-Tax-Amount')" v-model="VergiParametre.AlanVergisiTutar" :autocomplete="'autocomplete'"></parainput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.AlanVergisiKdv" :autocomplete="'autocomplete'">
                            </yuzdeinput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <v-select hide-details="" v-model="VergiParametre.AlanVergisiDH" :items="itemsei" clearable label="E/I">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md5>
                            <v-text-field hide-details="" v-model="VergiParametre.AlanVergisiAciklama" :label="$t('Description')">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                            <v-checkbox v-model="VergiParametre.AlanVergisiDisp" hide-details></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 sm4 md2>
                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'Tax1 Tutar'" v-model="VergiParametre.Tax1Tutar" :autocomplete="'autocomplete'">
                            </parainput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.Tax1Kdv" :autocomplete="'autocomplete'">
                            </yuzdeinput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <v-select hide-details="" v-model="VergiParametre.Tax1DH" :items="itemsei" clearable label="E/I">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md5>
                            <v-text-field hide-details="" v-model="VergiParametre.Tax1Aciklama" :label="$t('Description')">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                            <v-checkbox v-model="VergiParametre.Tax1Disp" hide-details></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 sm4 md2>
                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'Tax2 Tutar'" v-model="VergiParametre.Tax2Tutar" :autocomplete="'autocomplete'">
                            </parainput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.Tax2Kdv" :autocomplete="'autocomplete'">
                            </yuzdeinput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <v-select hide-details="" v-model="VergiParametre.Tax2DH" :items="itemsei" clearable label="E/I">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md5>
                            <v-text-field hide-details="" v-model="VergiParametre.Tax2Aciklama" :label="$t('Description')">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                            <v-checkbox v-model="VergiParametre.Tax2Disp" hide-details></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 sm4 md2>
                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'Tax3 Tutar'" v-model="VergiParametre.Tax3Tutar" :autocomplete="'autocomplete'">
                            </parainput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.Tax3Kdv" :autocomplete="'autocomplete'">
                            </yuzdeinput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <v-select hide-details="" v-model="VergiParametre.Tax3DH" :items="itemsei" clearable label="E/I">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md5>
                            <v-text-field hide-details="" v-model="VergiParametre.Tax3Aciklama" :label="$t('Description')">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                            <v-checkbox v-model="VergiParametre.Tax3Disp" hide-details></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 sm4 md2>
                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'Tax4 Tutar'" v-model="VergiParametre.Tax4Tutar" :autocomplete="'autocomplete'">
                            </parainput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.Tax4Kdv" :autocomplete="'autocomplete'">
                            </yuzdeinput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <v-select hide-details="" v-model="VergiParametre.Tax4DH" :items="itemsei" clearable label="E/I">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md5>
                            <v-text-field hide-details="" v-model="VergiParametre.Tax4Aciklama" :label="$t('Description')">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                            <v-checkbox v-model="VergiParametre.Tax4Disp" hide-details></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 sm4 md2>
                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Other-Service-Amount')" :aktif="'false'" v-model="defaultvalue" :autocomplete="'autocomplete'"></parainput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.DigerServisKdv" :autocomplete="'autocomplete'">
                            </yuzdeinput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <v-select hide-details="" v-model="VergiParametre.DigerServisDH" :items="itemsei" clearable label="E/I">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md5>
                            <v-text-field hide-details="" v-model="VergiParametre.DigerServisAciklama" :label="$t('Description')">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                            <v-checkbox v-model="VergiParametre.DigerServisDisp" hide-details></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 sm4 md2>
                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Domestic-Service-Amount')" :aktif="'false'" v-model="defaultvalue" :autocomplete="'autocomplete'"></parainput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.IcServisKdv" :autocomplete="'autocomplete'">
                            </yuzdeinput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <v-select hide-details="" v-model="VergiParametre.IcServisDH" :items="itemsei" clearable label="E/I">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md5>
                            <v-text-field hide-details="" v-model="VergiParametre.IcServisAciklama" :label="$t('Description')">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                            <v-checkbox v-model="VergiParametre.IcServisDisp" hide-details></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 sm4 md2>
                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('International-Service-Amount')" :aktif="'false'" v-model="defaultvalue" :autocomplete="'autocomplete'"></parainput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.DisServisKdv" :autocomplete="'autocomplete'">
                            </yuzdeinput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <v-select hide-details="" v-model="VergiParametre.DisServisDH" :items="itemsei" clearable label="E/I">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md5>
                            <v-text-field hide-details="" v-model="VergiParametre.DisServisAciklama" :label="$t('Description')">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                            <v-checkbox v-model="VergiParametre.DisServisDisp" hide-details></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 sm4 md2>
                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('One-way-EKP')" v-model="VergiParametre.TekYonTutar" :autocomplete="'autocomplete'">
                            </parainput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.TekYonKdv" :autocomplete="'autocomplete'">
                            </yuzdeinput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <v-select hide-details="" v-model="VergiParametre.TekYonDH" :items="itemsei" clearable label="E/I">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md5>
                            <v-text-field hide-details="" v-model="VergiParametre.TekYonAciklama" :label="$t('Description')">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                            <v-checkbox v-model="VergiParametre.TekYonDisp" hide-details></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 sm4 md2>
                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Return-EKP')" v-model="VergiParametre.GDonusTutar" :autocomplete="'autocomplete'">
                            </parainput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.GDonusKdv" :autocomplete="'autocomplete'">
                            </yuzdeinput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <v-select hide-details="" v-model="VergiParametre.GDonusDH" :items="itemsei" clearable label="E/I">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md5>
                            <v-text-field hide-details="" v-model="VergiParametre.GDonusAciklama" :label="$t('Description')">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                            <v-checkbox v-model="VergiParametre.GDonusDisp" hide-details></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 sm4 md2>
                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="RezTutarEtiket" v-model="VergiParametre.ReserveTutar" :autocomplete="'autocomplete'"></parainput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.ReserveKdv" :autocomplete="'autocomplete'">
                            </yuzdeinput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <v-select hide-details="" v-model="VergiParametre.ReserveDH" :items="itemsei" clearable label="E/I">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md5>
                            <v-text-field hide-details="" v-model="VergiParametre.ReserveAciklama" :label="$t('Description')">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                            <v-checkbox v-model="VergiParametre.ReserveDisp" hide-details></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 sm4 md2>
                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Penalty-Amount')" v-model="VergiParametre.CezaTutar" :autocomplete="'autocomplete'">
                            </parainput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.CezaKdv" :autocomplete="'autocomplete'">
                            </yuzdeinput>
                        </v-flex>
                        <v-flex xs12 sm4 md2>
                            <v-select hide-details="" v-model="VergiParametre.CezaDH" :items="itemsei" clearable label="E/I">
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md5>
                            <v-text-field hide-details="" v-model="VergiParametre.CezaAciklama" :label="$t('Description')">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                            <v-checkbox v-model="VergiParametre.CezaDisp" hide-details></v-checkbox>
                        </v-flex>
                    </v-layout>

                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-checkbox v-model="VergiParametre.ReserveDisHatKdv" hide-details label="Değişken Alandan Dış Hat Biletlerde Kdv Ayrılmasın" style="padding-bottom:12px;font-size:14px;"> </v-checkbox>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="vergikaydetkapat()">{{ $t('OK') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog scrollable="" persistent v-model="dialoggecicivergi" max-width="600px">
            <v-card flat color="grey lighten-5">
                <v-toolbar size="120px" color="info">
                    <v-toolbar-title class="white--text">  {{ $t('Temporary-Tax-List') }} </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>

                    <v-layout row="" wrap="">

                        <v-flex xs12 sm12 md12>

                            <v-layout row wrap>
                                <v-flex xs12 sm4 md2>
                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'Tutar'" :aktif="'false'" v-model="defaultvalue" :autocomplete="'autocomplete'">
                                    </parainput>
                                </v-flex>
                                <v-flex xs12 sm4 md2>
                                    <yuzdeinput :isPositive="true" :etiket="$t('VAT') + ' %'" v-model="VergiParametre.BiletKdv" :autocomplete="'autocomplete'">
                                    </yuzdeinput>
                                </v-flex>
                                <v-flex xs12 sm4 md2>
                                    <v-select hide-details="" v-model="VergiParametre.BiletDH" :items="itemsei" clearable label="E/I">
                                    </v-select>
                                </v-flex>
                                <v-flex xs12 sm4 md5>
                                    <v-text-field hide-details="" v-model="VergiParametre.BiletAciklama" :label="$t('Description')">
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm4 md1>
                                    <v-checkbox v-model="VergiParametre.BiletDisp" hide-details></v-checkbox>
                                </v-flex>
                            </v-layout>

                        </v-flex>

                        <v-flex xs12 sm12 md12>
                            <v-btn small @click="Ara()" color="info" block>{{$t('Search')}}</v-btn>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                            <v-card flat class="white--text">
                                <v-card-actions>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm12 md12>
                                            <v-toolbar flat="" size="100px" dark color="info">
                                                <v-toolbar-title> <span class="subheading white--text">
                                                     {{$t('PNR-List')}}
                                                    </span> </v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-flex xs6 sm6 md6>
                                                    <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet" label="Bulunan kayıtlarda ara" append-icon="search"></v-text-field>
                                                </v-flex>
                                            </v-toolbar>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12>
                                            <v-data-table :headers="headersservis" :loading="progress" :items="items" hide-actions class="elevation-1">
                                                <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                                                <template slot="items" slot-scope="props">
                                                    <tr @click="kabul(props.item)" item>
                                                        <td class="text-xs-left">{{ props.item.PNR_No }}</td>
                                                        <td class="text-xs-left">{{ props.item.Isim }}</td>
                                                        <td class="text-xs-left">{{ props.item.Cari_Kod }}</td>
                                                        <td class="text-xs-left">{{ props.item.Kayit_Tarihi | dateformat }}</td>
                                                        <td class="justify-center layout px-0">
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </v-flex>

                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="gecicivergikaydetkapat()">
                        {{$t("cancel_button")}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <template>
            <v-card>
                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                    {{ text1 }}

                    <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
                </v-snackbar>
            </v-card>
        </template>

    </v-container>
</div>
</template>

<script>
import auth from '../../../api/auth'
import helpers from "@/components/app/customcomp/helpers.js"
import parainput from "@/components/app/customcomp/parainput.vue"
import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"

export default {
    data() {
        return {

            searchsatilanbilet: null,
            secilencari: null,
            prm: {

                Isim: null,
                Cari_Kod: null,
                Kayit_Tarihi1: null,
                Kayit_Tarihi2: null,
            },
            kodmesajı: null,
            progress: false,
            items: [],
            aranacakkelime: null,
            secilendeger: null,
            dialog: false,
            kur: null,
            icYuzdedenHesapla: {
                Yuzdeden: false,
                HesapTipi: null,
                HesapYuzde: 0
            },
            DisYuzdedenHesapla: {
                Yuzdeden: false,
                HesapTipi: null,
                HesapYuzde: 0
            },

            ServisParametre: {
                ServisKod11: 11,
                Doviztip11: null,
                Fiyat11: 0,
                DefaultServis11: false,

                ServisKod12: 12,
                Doviztip12: null,
                Fiyat12: 0,
                DefaultServis12: false,

                ServisKod13: 13,
                Doviztip13: null,
                Fiyat13: 0,
                DefaultServis13: false,

                ServisKod15: 15,
                Doviztip15: null,
                Fiyat15: 0,
                DefaultServis15: false,

                ServisKod19: 19,
                Doviztip19: null,
                Fiyat19: 0,
                DefaultServis19: false,
                ServisKod21: 21,

                Doviztip21: null,
                Fiyat21: 0,
                DefaultServis21: false,

                ServisKod22: 22,
                Doviztip22: null,
                Fiyat22: 0,
                DefaultServis22: false,

                ServisKod31: 31,
                Doviztip31: null,
                Fiyat31: 0,
                DefaultServis31: false,

                ServisKod32: 32,
                Doviztip32: null,
                Fiyat32: 0,
                DefaultServis32: false,

                ServisKod33: 33,
                Doviztip33: null,
                Fiyat33: 0,
                DefaultServis33: false,

                ServisKod40: 40,
                Doviztip40: null,
                Fiyat40: 0,
                DefaultServis40: false,

                ServisKod44: 44,
                Doviztip44: null,
                Fiyat44: 0,
                DefaultServis44: false,
            }

            ,
            doviztipi: [],
            dialogservis: false,
            itemsei: ['E', 'I'],
            defaultvalue: 0,
            date: null,
            dateFormatted: null,
            menu: false,
            drawer: null,
            baslik: '',
            dialogvergi: false,
            dialoggecicivergi: false,
            FirmaParametre: {
                FirmaAdi: null,
                FirmaAdres: null,
                FirmaAdres2: null,
                BankaHesapNo: null,
                BankaSube: null,
                Tel1: null,
                Tel2: null,
                Tel3: null,
                Tel4: null,
                Tel5: null,
                VergiDaire: null,
                VergiNo: null,
                UlkeKod: null,
                UlkeIataKod: null,
                ParaBirimi: null,
                AcentaVatKod: null,
                SmsMusteriKod: null,
                SmsSifre: null,
                XmlSaticiKod: null
            },
            VergiParametre: {
                SirketKodu: 0,
                BiletKdv: 0,
                BiletDH: null,
                BiletAciklama: null,
                BiletDisp: false,

                PtaKdv: 0,
                PtaDH: null,
                PtaAciklama: null,
                PtaDisp: false,

                YffTutar: 0,
                YffKdv: 0,
                YffDH: null,
                YffAciklama: null,
                YffDisp: false,

                AlanVergisiTutar: 0,
                AlanVergisiKdv: 0,
                AlanVergisiDH: null,
                AlanVergisiAciklama: null,
                AlanVergisiDisp: false,

                Tax1Tutar: 0,
                Tax1Kdv: 0,
                Tax1DH: null,
                Tax1Aciklama: null,
                Tax1Disp: false,

                Tax2Tutar: 0,
                Tax2Kdv: 0,
                Tax2DH: null,
                Tax2Aciklama: null,
                Tax2Disp: false,

                Tax3Tutar: 0,
                Tax3Kdv: 0,
                Tax3DH: null,
                Tax3Aciklama: null,
                Tax3Disp: false,

                Tax4Tutar: 0,
                Tax4Kdv: 0,
                Tax4DH: null,
                Tax4Aciklama: null,
                Tax4Disp: false,

                DigerServisTutar: 0,
                DigerServisKdv: 0,
                DigerServisDH: null,
                DigerServisAciklama: null,
                DigerServisDisp: false,

                IcServisTutar: 0,
                IcServisKdv: 0,
                IcServisDH: null,
                IcServisAciklama: null,
                IcServisDisp: false,

                DisServisTutar: 0,
                DisServisKdv: 0,
                DisServisDH: null,
                DisServisAciklama: null,
                DisServisDisp: false,

                TekYonTutar: 0,
                TekYonKdv: 0,
                TekYonDH: null,
                TekYonAciklama: null,
                TekYonDisp: false,

                GDonusTutar: 0,
                GDonusKdv: 0,
                GDonusDH: null,
                GDonusAciklama: null,
                GDonusDisp: false,

                ReserveTutar: 0,
                ReserveKdv: 0,
                ReserveDH: null,
                ReserveAciklama: null,
                ReserveDisp: false,

                CezaTutar: 0,
                CezaKdv: 0,
                CezaDH: null,
                CezaAciklama: null,
                CezaDisp: false,

                ReserveDisHatKdv: false,
            },
            tumparametreler: [],
            text1: '',
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            RezTutarEtiket: 'Reserve Tutar',
        }
    },

    methods: {
        gecicivergibilgigetir() {

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            var params = {
                ID: null,
                CompanyCode: credentials.SirketKodu
            }

            this.$http.post(auth.API_URL + 'api/TicketParametre/TempTaxParamList', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                //   this.VergiParametre = response.body
                this.dialoggecicivergi = true
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })

        },
        getparabirimi() {
            return helpers.getparabirimi()
        },

        karsidegeral(val) {
            if (val == true) {
                return false
            } else if (val == false) {
                return false
            }
        },
        DefaultIcAyarlar(a, b) {
            var nerden = b
            if (this.ServisParametre.DefaultServis11 == true && nerden != '11') {
                this.ServisParametre.DefaultServis11 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis12 === true && nerden != '12') {
                this.ServisParametre.DefaultServis12 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis13 === true && nerden != '13') {
                this.ServisParametre.DefaultServis13 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis15 === true && nerden != '15') {
                this.ServisParametre.DefaultServis15 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis19 === true && nerden != '19') {
                this.ServisParametre.DefaultServis19 = this.karsidegeral(a)
            }
        },
        DefaultDisAyarlar(a, b) {
            var nerden = b
            if (this.ServisParametre.DefaultServis21 == true && nerden != '21') {
                this.ServisParametre.DefaultServis21 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis22 === true && nerden != '22') {
                this.ServisParametre.DefaultServis22 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis31 === true && nerden != '31') {
                this.ServisParametre.DefaultServis31 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis32 === true && nerden != '32') {
                this.ServisParametre.DefaultServis32 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis33 === true && nerden != '33') {
                this.ServisParametre.DefaultServis33 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis40 === true && nerden != '40') {
                this.ServisParametre.DefaultServis40 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis44 === true && nerden != '44') {
                this.ServisParametre.DefaultServis44 = this.karsidegeral(a)
            }

        },
        Kaydet: Kaydet,
        firmabilgilerigetir: firmabilgilerigetir,
        vergibilgigetir: vergibilgigetir,
        vergikaydetkapat: vergikaydetkapat,
        servisbilgigetir: servisbilgigetir,
        serviskaydet: serviskaydet,
        gecicivergikaydetkapat
    },
    computed:{
            headersservis(){
                return [{
                    text: 'PNR',
                    value: 'BolumKodu'
                },
                {
                    text: this.$t('Name'),
                    value: 'BolumAdi',

                },
                {
                    text: this.$t('Current'),
                    value: 'BolumAdi',

                },
                {
                    text: this.$t('Date'),
                    value: 'BolumAdi',

                }
            ]
            },
            hesaptipi(){
                return [{
                    text: this.$t('Ticket-Amount'),
                    value: 0
                },
                {
                    text: this.$t('Ticket-Amount') + '+' + this.$t('Taxes'),
                    value: 1
                }
            ]
            },
    },
    components: {
        parainput,
        yuzdeinput
    }
}

function serviskaydet() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var yenidizi = [];

    var yenikayit = {
        SirketKodu: credentials.SirketKodu,
        ServisKod: '11',
        Aciklama: $t('Domestic-Low-Cost'),
        Fiyat: this.ServisParametre.Fiyat11,
        DovizTip: this.ServisParametre.Doviztip11,
        Yuzdeden: this.icYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.icYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.icYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis11
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        ServisKod: '12',
        Aciklama: 'İç Eco Cost',
        Fiyat: this.ServisParametre.Fiyat12,
        DovizTip: this.ServisParametre.Doviztip12,
        Yuzdeden: this.icYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.icYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.icYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis12
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        ServisKod: '13',
        Aciklama: 'İç Business',
        Fiyat: this.ServisParametre.Fiyat13,
        DovizTip: this.ServisParametre.Doviztip13,
        Yuzdeden: this.icYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.icYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.icYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis13
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        ServisKod: '15',
        Aciklama: 'İç İade',
        Fiyat: this.ServisParametre.Fiyat15,
        DovizTip: this.ServisParametre.Doviztip15,
        Yuzdeden: this.icYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.icYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.icYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis15
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        ServisKod: '19',
        Aciklama: 'İç Rezervasyon Değişimi',
        Fiyat: this.ServisParametre.Fiyat19,
        DovizTip: this.ServisParametre.Doviztip19,
        Yuzdeden: this.icYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.icYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.icYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis19
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        ServisKod: '21',
        Aciklama: 'Dış Short Cost',
        Fiyat: this.ServisParametre.Fiyat21,
        DovizTip: this.ServisParametre.Doviztip21,
        Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis21
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        ServisKod: '22',
        Aciklama: 'Dış Short Business',
        Fiyat: this.ServisParametre.Fiyat22,
        DovizTip: this.ServisParametre.Doviztip22,
        Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis22
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        ServisKod: '31',
        Aciklama: 'Dış Long Eco',
        Fiyat: this.ServisParametre.Fiyat31,
        DovizTip: this.ServisParametre.Doviztip31,
        Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis31
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        ServisKod: '32',
        Aciklama: 'Dış Long Business',
        Fiyat: this.ServisParametre.Fiyat32,
        DovizTip: this.ServisParametre.Doviztip32,
        Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis32
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        ServisKod: '33',
        Aciklama: 'First Class',
        Fiyat: this.ServisParametre.Fiyat33,
        DovizTip: this.ServisParametre.Doviztip33,
        Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis33
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        ServisKod: '40',
        Aciklama: 'Dış İade',
        Fiyat: this.ServisParametre.Fiyat40,
        DovizTip: this.ServisParametre.Doviztip40,
        Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis40
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        ServisKod: '44',
        Aciklama: 'Dış Rezervasyon Değişimi',
        Fiyat: this.ServisParametre.Fiyat44,
        DovizTip: this.ServisParametre.Doviztip44,
        Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis44
    }
    yenidizi.push(yenikayit);

    var params = yenidizi;

    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketServiceParametreAdd', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        if (response.body.Status == true) {
            this.dialogservis = false
        }

         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true

    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        }
    })

}

function Kaydet() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
        GenelParametre: this.tumparametreler.GenelParametre,
        RaporParametre: this.tumparametreler.RaporParametre,
        FirmaParametre: this.FirmaParametre,
        SirketKodu: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketParametreAdd', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true
        this.dialog = false

    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

        }
    })
}

function gecicivergikaydetkapat() {
    this.dialoggecicivergi = false

    // var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    // this.VergiParametre.SirketKod = credentials.SirketKodu;

    // var params = this.VergiParametre;

    // this.$http.post(auth.API_URL + 'api/TicketParametre/TicketTaxParametreAdd', params, {
    //   headers: {
    //     'Authorization': 'Bearer ' + auth.getAuthHeader()
    //   }
    // }).then((response) => {

    //   this.dialogvergi = false;
    //    this.text1 = this.$t(response.body.ResponseMessage)
    //   this.snackbar = true

    // }, (response) => {
    //   if (response.status === 0) {
    //     this.text1 = 'Service Unavailable'
    //     this.snackbar = true

    //   } else {
    //     this.text1 = 'Service Unavailable'
    //     this.snackbar = true

    //   }
    //})
}

function vergikaydetkapat() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.VergiParametre.SirketKod = credentials.SirketKodu;

    var params = this.VergiParametre;

    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketTaxParametreAdd', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        this.dialogvergi = false;
         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true

    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

        }
    })

}

function servisbilgigetir() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var params = {
        CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketServiceParametreLoad', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        response.body.forEach(element => {

            if (element.ServisKod == '11') {
                this.ServisParametre.Fiyat11 = element.Fiyat;
                this.ServisParametre.Doviztip11 = element.DovizTip;
                this.ServisParametre.DefaultServis11 = element.DefaultServis;
                this.icYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                this.icYuzdedenHesapla.HesapTipi = element.HesapTipi;
                this.icYuzdedenHesapla.HesapYuzde = element.HesapYuzde
            }

            if (element.ServisKod == '12') {

                this.ServisParametre.Fiyat12 = element.Fiyat;
                this.ServisParametre.Doviztip12 = element.DovizTip;
                this.ServisParametre.DefaultServis12 = element.DefaultServis;
                this.icYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                this.icYuzdedenHesapla.HesapTipi = element.HesapTipi;
                this.icYuzdedenHesapla.HesapYuzde = element.HesapYuzde
            }

            if (element.ServisKod == '13') {

                this.ServisParametre.Fiyat13 = element.Fiyat;
                this.ServisParametre.Doviztip13 = element.DovizTip;
                this.ServisParametre.DefaultServis13 = element.DefaultServis;
                this.icYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                this.icYuzdedenHesapla.HesapTipi = element.HesapTipi;
                this.icYuzdedenHesapla.HesapYuzde = element.HesapYuzde
            }

            if (element.ServisKod == '15') {
                this.ServisParametre.Fiyat15 = element.Fiyat;
                this.ServisParametre.Doviztip15 = element.DovizTip;
                this.ServisParametre.DefaultServis15 = element.DefaultServis;
                this.icYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                this.icYuzdedenHesapla.HesapTipi = element.HesapTipi;
                this.icYuzdedenHesapla.HesapYuzde = element.HesapYuzde
            }

            if (element.ServisKod == '19') {
                this.ServisParametre.Fiyat19 = element.Fiyat;
                this.ServisParametre.Doviztip19 = element.DovizTip;
                this.ServisParametre.DefaultServis19 = element.DefaultServis;
                this.icYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                this.icYuzdedenHesapla.HesapTipi = element.HesapTipi;
                this.icYuzdedenHesapla.HesapYuzde = element.HesapYuzde
            }

            if (element.ServisKod == '21') {
                this.ServisParametre.Fiyat21 = element.Fiyat;
                this.ServisParametre.Doviztip21 = element.DovizTip;
                this.ServisParametre.DefaultServis21 = element.DefaultServis;
                this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
                this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
            }

            if (element.ServisKod == '22') {
                this.ServisParametre.Fiyat22 = element.Fiyat;
                this.ServisParametre.Doviztip22 = element.DovizTip;
                this.ServisParametre.DefaultServis22 = element.DefaultServis;
                this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
                this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
            }

            if (element.ServisKod == '31') {
                this.ServisParametre.Fiyat31 = element.Fiyat;
                this.ServisParametre.Doviztip31 = element.DovizTip;
                this.ServisParametre.DefaultServis31 = element.DefaultServis;
                this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
                this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
            }

            if (element.ServisKod == '32') {
                this.ServisParametre.Fiyat32 = element.Fiyat;
                this.ServisParametre.Doviztip32 = element.DovizTip;
                this.ServisParametre.DefaultServis32 = element.DefaultServis;
                this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
                this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
            }

            if (element.ServisKod == '33') {
                this.ServisParametre.Fiyat33 = element.Fiyat;
                this.ServisParametre.Doviztip33 = element.DovizTip;
                this.ServisParametre.DefaultServis33 = element.DefaultServis;
                this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
                this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
            }

            if (element.ServisKod == '40') {
                this.ServisParametre.Fiyat40 = element.Fiyat;
                this.ServisParametre.Doviztip40 = element.DovizTip;
                this.ServisParametre.DefaultServis40 = element.DefaultServis;
                this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
                this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
            }

            if (element.ServisKod == '44') {
                this.ServisParametre.Fiyat44 = element.Fiyat;
                this.ServisParametre.Doviztip44 = element.DovizTip;
                this.ServisParametre.DefaultServis44 = element.DefaultServis;
                this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
                this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
            }

        });

    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        }
    })

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params1 = {
        CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/currency/List', params1, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.doviztipi = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-Döviz'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable-Döviz'
            this.snackbar = true
        }
    })

    this.dialogservis = true;
}

function vergibilgigetir() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var params = {
        CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketTaxParametreGet', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.VergiParametre = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        }
    })
    
    this.$http.post(auth.API_URL + 'api/TicketHelpers/GetReserveName', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
      if(response.body.length > 0 ){
        this.RezTutarEtiket = response.body
      }
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-class'
            this.progress = false
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable-class'
            this.progress = false
            this.snackbar = true
        }
    })

    this.dialogvergi = true;
}

function firmabilgilerigetir() {

    this.dialog = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
        CompanyCode: credentials.SirketKodu
    }
    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketParametreGet', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.tumparametreler = response.body
        this.FirmaParametre = response.body.FirmaParametre

    }, (response) => {
        if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true

        } else {
            this.text = 'Service Unavailable'
            this.snackbar = true

        }
    })
}
</script>
